import React, { useContext, useRef } from 'react';
import { MediaContext } from 'react-media-query-hoc';
import { Select } from '@domain-group/fe-blueprint-ui/select';
import { PinIcon } from '@domain-group/fe-co-icon';
import { aliasesForRegion } from '@domain-group/fe-allhomes-search-api';
import Dropdown from '@domain-group/fe-co-allhomes-dropdown';
import Selector from '../selector/selector';
import * as styles from './region-selector.style';
import * as dropdownStyles from '../dropdown.style';
import { regionGroupToOptions } from './region-group';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var RegionSelector = _ref => {
  var _filters$getSingleLoc, _optionBySlug;
  var regionGroup = _ref.regionGroup,
    filters = _ref.filters,
    _ref$onSubmitFilter = _ref.onSubmitFilter,
    onSubmitFilter = _ref$onSubmitFilter === void 0 ? () => {} : _ref$onSubmitFilter;
  var dropdownRef = useRef(null);
  var _useContext = useContext(MediaContext),
    mobile = _useContext.mobile,
    tablet = _useContext.tablet,
    desktop = _useContext.desktop;
  var selectedSlug = (_filters$getSingleLoc = filters.getSingleLocality()) === null || _filters$getSingleLoc === void 0 ? void 0 : _filters$getSingleLoc.slug;
  var aliases = aliasesForRegion("".concat(regionGroup.region.id));
  var options = regionGroupToOptions(regionGroup, aliases);
  var optionsWithState = regionGroupToOptions(regionGroup, aliases, {
    withState: true
  });
  var optionBySlug = slug => options.find(option => option.value === slug);
  var selectedOption = (_optionBySlug = optionBySlug(selectedSlug)) !== null && _optionBySlug !== void 0 ? _optionBySlug : options[0];
  var onSelect = localitySlug => {
    var locality = optionBySlug(localitySlug);
    if (locality) {
      var id = locality.id,
        type = locality.type,
        slug = locality.value;
      onSubmitFilter(filters.cloneWithLocalities([{
        id,
        type,
        slug
      }]));
    }
  };
  return ___EmotionJSX("span", {
    css: styles.regionSelector(options.findIndex(option => option.label === 'Nearby Districts'))
  }, ___EmotionJSX(PinIcon, {
    size: "small",
    css: styles.regionIcon
  }), mobile && ___EmotionJSX(Select, {
    label: "region-selector",
    options: optionsWithState,
    value: selectedOption.value,
    onChange: option => {
      if (option !== null && option !== void 0 && option.value) {
        onSelect(option.value);
      }
    },
    labelHidden: true
  }), (tablet || desktop) && ___EmotionJSX(Dropdown, {
    css: dropdownStyles.dropdown,
    align: "centre",
    ref: dropdownRef,
    title: selectedOption.label,
    anchorClass: "allhomes-dropdown-anchor"
  }, ___EmotionJSX(Selector, {
    options: options,
    selectedValue: selectedOption.value,
    onSelect: onSelect
  })));
};